import React, {useEffect, useState} from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation, Outlet } from 'react-router-dom'
import { NavLink } from 'react-router-dom';
import { getUser } from '../auth';

import { Button, Container, Col, Navbar, Offcanvas, Row } from 'react-bootstrap';

import { NavigationBar } from './Navigation/NavigationBar';
export const Root = () => {
  const auth = useAuth();
  
  useEffect(() => {
    const handleStorageChange = () => {
      if(getUser() === null){
        // User was removed from another tab — no id_token available,
        // so redirect to logged_out page directly instead of hitting the auth server
        window.location.href = '/logged_out';
      }
    }
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    }

  }, [])
  return <>
  <Container fluid className='root-container'>
    <NavigationBar/>
    <Container fluid className="content-container"> 
      <Outlet/>
    </Container>
    <footer className="mt-auto">
      <Container fluid>
      <Row>
        <Col className="d-flex justify-content-start">
          <p>© {new Date().getFullYear()} Milliman, Inc. All rights reserved.</p>
        </Col>
        <Col className="d-flex justify-content-end">
          <p>GridStep 4.0.0</p>
        </Col>
      </Row>
      </Container>
      </footer>
  </Container>
  </>
}